// extracted by mini-css-extract-plugin
module.exports = {"root":"o5bxv1","logo":"leAV7Y"};